module.exports = __webpack_public_path__ + "media/images/logos/discord-light-9da066bddccab97cea53e88add977f4f.svg";